import { StudentsHeader } from "./StudentsHeader";
import { EntitySectionLayout } from "@/shared/components/common/EntitySectionLayout";

export function StudentsLayout() {
  return (
    <EntitySectionLayout
      basePath="/students"
      HeaderComponent={StudentsHeader}
      hideHeaderMatchers={["add-students", "edit/"]}
    />
  );
}
